import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { HouseSimple, Hospital, UsersThree, ShieldCheck } from '@phosphor-icons/react';

const navItems = [
  { path: '/', label: 'Home', icon: HouseSimple },
  { path: '/clinics', label: 'Clinics', icon: Hospital },
  { path: '/clinicians', label: 'Clinicians', icon: UsersThree },
];

export default function Sidebar({ user, open, onClose }) {
  const navigate = useNavigate();

  return (
    <aside className={`fixed left-0 top-[56px] md:top-0 h-[calc(100vh-56px)] md:h-screen w-[250px] flex flex-col z-10 pt-4 md:pt-8 pb-6 px-6 transition-transform md:translate-x-0 bg-white md:bg-transparent border-r border-[#E6E6E6] md:border-0 ${open ? 'translate-x-0' : '-translate-x-full'}`}>
      {/* Logo - hidden on mobile since it's in the header */}
      <div className="cursor-pointer mb-8 hidden md:block" onClick={() => { navigate('/'); onClose?.(); }}>
        <img src="/cscore-logo.png" alt="CScore" className="ml-[12px]" style={{ maxWidth: '70%', aspectRatio: '900 / 197' }} />
      </div>

      {/* Navigation */}
      <nav className="flex-1">
        {navItems.map(({ path, label, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            end={path === '/'}
            onClick={() => onClose?.()}
            style={({ isActive }) => isActive ? {
              backgroundColor: '#F5E9FD',
              boxShadow: 'inset -2px -2px 4px 0px #AAAAAA',
            } : undefined}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg mb-2 text-[14px] font-semibold transition-colors outline-none ${
                isActive
                  ? 'text-primary bg-[#F5E9FD] md:bg-transparent'
                  : 'text-gray-700 md:text-white/90 hover:bg-gray-100 md:hover:bg-[#9653E8] hover:text-gray-900 md:hover:text-white'
              }`
            }
          >
            <Icon size={22} weight="regular" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Admin Page link — super admins only */}
      {user?.user_type === 'super_admin' && (
        <button
          type="button"
          onClick={() => { navigate('/admin/users'); onClose?.(); }}
          className="flex items-center gap-3 px-4 py-3 rounded-lg mb-3 text-[14px] font-semibold text-gray-700 md:text-white/90 hover:bg-gray-100 md:hover:bg-[#9653E8] hover:text-gray-900 md:hover:text-white transition-colors w-full"
        >
          <ShieldCheck size={22} weight="regular" />
          Admin Page
        </button>
      )}

      {/* User Profile - hidden on mobile, shown in header instead */}
      <div
        className="p-3 rounded-xl cursor-pointer transition-colors hidden md:block"
        style={{
          background: 'radial-gradient(ellipse farthest-corner at 10% 10%, #6C18C9, #B279F0)',
        }}
        onClick={() => { navigate('/settings'); onClose?.(); }}
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white/30 overflow-hidden flex-shrink-0">
            {user?.profile_picture_url ? (
              <img src={user.profile_picture_url} alt="" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-white text-sm font-semibold">
                {user?.first_name?.[0]}{user?.last_name?.[0]}
              </div>
            )}
          </div>
          <div className="min-w-0">
            <p className="text-white text-sm font-semibold truncate">
              {user?.first_name} {user?.last_name}
            </p>
            <p className="text-white/70 text-xs truncate">
              {user?.email}
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
}
